import React from 'react';

function Footer() {
  return (
    <footer className="bg-blue-900 text-white text-center p-4">
      &copy; {new Date().getFullYear()} Cidade Serena Guesthouse. All rights reserved.
    </footer>
  );
}

export default Footer;
